import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import TeamsTableContainer from "./teams/TeamsTableContainer";
import StructureFasesContainer from "./structure/StructureFasesContainer";
import RankingTable from "../components/results/RankingTable";
import PlayerRankingTable from "../components/results/PlayerRankingTable";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Button from "@material-ui/core/Button";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";

const styles = (theme) => ({
  root: {
    width: "100%",
  },
});

class DivisionTabsContainer extends React.Component {
  state = {
    open: false,
    anchorEl: null,
    selectedDivision: "0",
  };

  UNSAFE_componentWillMount = () => {
    let divisionsSorted = this.props.divisions.sort((a, b) => {
      if (a.num > b.num) {
        return 1;
      } else if (a.num < b.num) {
        return -1;
      }
      if (a.id > b.id) {
        return 1;
      } else if (a.id < b.id) {
        return -1;
      } else {
        return 0;
      }
    });

    this.setState({ selectedDivision: (divisionsSorted[0] || {}).id || "0" });
  };

  selectDivision = (divisionId) => {
    this.setState({ selectedDivision: divisionId, anchorEl: null });
    if (this.props.playerRankingPage) {
      this.props.selectPhase("all");
    }
  };

  handleMenu = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const { classes } = this.props;

    let dropdown = (
      <div>
        <Button
          size="small"
          variant="outlined"
          color="default"
          onClick={this.handleMenu}
          style={{ marginRight: 10 }}
          endIcon={<KeyboardArrowDownIcon />}
        >
          {(this.props.divisionsObject[this.state.selectedDivision] || {})
            .name || ""}
        </Button>
        <Menu
          id="menu-days"
          anchorEl={this.state.anchorEl}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          getContentAnchorEl={null}
          open={Boolean(this.state.anchorEl)}
          onClose={this.handleClose}
        >
          {this.props.divisions.map((division) => (
            <MenuItem
              key={division.id}
              selected={this.state.selectedDivision === division.id}
              onClick={(e) => this.selectDivision(division.id)}
              style={{ paddingRight: 50 }}
            >
              {division.name}
            </MenuItem>
          ))}
        </Menu>
      </div>
    );

    let teamsTablePerDivision = {};
    if (this.props.teamPage) {
      this.props.divisions.forEach((division) => {
        teamsTablePerDivision[division.id] = (
          <TeamsTableContainer
            key={division.id}
            tournament={this.props.tournament}
            division={division}
            divisions={this.props.divisions}
            teamsContactInfo={this.props.teamsContactInfo}
            contactInfoLoaded={this.props.contactInfoLoaded}
            playersContactInfo={this.props.playersContactInfo}
            playersContactInfoLoaded={this.props.playersContactInfoLoaded}
            tournamentStatus={this.props.tournamentStatus}
            toggleFinishedDialog={this.props.toggleFinishedDialog}
            dropdown={this.props.divisions.length > 1 ? dropdown : null}
            user={this.props.user}
            days={this.props.days}
            daysByKey={this.props.daysByKey}
            daysLoaded={this.props.daysLoaded}
            divisionsObject={this.props.divisionsObject}
          />
        );
      });
    }

    let structurePerDivision = {};
    if (this.props.structurePage) {
      this.props.divisions.forEach((division) => {
        structurePerDivision[division.id] = (
          <StructureFasesContainer
            key={division.id}
            tournament={this.props.tournament}
            division={division}
            divisions={this.props.divisions}
            divisionsObject={this.props.divisionsObject}
            numDivided={this.props.numDivided}
            teams={(this.props.teamsPerDivision[division.id] || []).sort(
              (a, b) => {
                return a.name > b.name;
              }
            )}
            teamsLoaded={this.props.teamsLoaded}
            maxTeams={this.props.maxTeams}
            user={this.props.user}
            userStatus={this.props.userStatus}
            tournamentStatus={this.props.tournamentStatus}
            toggleFinishedDialog={this.props.toggleFinishedDialog}
            userData={this.props.userData}
            daysByKey={this.props.daysByKey}
          />
        );
      });
    }

    return (
      <div className={classes.root}>
        {!this.props.teamPage && this.props.divisions.length > 1 && dropdown}
        <div>
          {this.props.teamPage &&
            (teamsTablePerDivision[this.state.selectedDivision] ||
              teamsTablePerDivision["0"])}
          {this.props.structurePage &&
            (structurePerDivision[this.state.selectedDivision] ||
              structurePerDivision["0"])}
          {this.props.ranking && (
            <RankingTable
              tournament={this.props.tournament}
              ranking={this.props.ranking[this.state.selectedDivision]}
              division={this.state.selectedDivision}
              customPoints={this.props.customPoints}
              useSets={(this.props.tournament.useSets || "0") === "1"}
            />
          )}
          {this.props.rankingPlayers && (
            <PlayerRankingTable
              tournament={this.props.tournament}
              ranking={
                this.props.rankingPlayers[this.state.selectedDivision] || []
              }
              division={this.state.selectedDivision}
              sort={this.props.sort}
              handleSortChange={this.props.handleSortChange}
              divisionsObject={this.props.divisionsObject}
              selectedPhase={this.props.selectedPhase}
              anchorElPhase={this.props.anchorElPhase}
              handleMenuPhase={this.props.handleMenuPhase}
              handleClosePhase={this.props.handleClosePhase}
              selectPhase={this.props.selectPhase}
            />
          )}
        </div>
      </div>
    );
  }
}

DivisionTabsContainer.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(DivisionTabsContainer);
